import { render, staticRenderFns } from "./FieldsItem.vue?vue&type=template&id=21756ff9&scoped=true"
import script from "./FieldsItem.vue?vue&type=script&lang=js"
export * from "./FieldsItem.vue?vue&type=script&lang=js"
import style0 from "./FieldsItem.vue?vue&type=style&index=0&id=21756ff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21756ff9",
  null
  
)

export default component.exports